import React from 'react';

import { XIcon } from '@heroicons/react/outline';
import { useHistory } from 'react-router-dom';

import Button from 'partial/components/Button';
import { SolidLogo } from 'modules/common/components/AppIconLogo';

function PrivacyPolicy() {
  const history = useHistory();
  return (
    <div className="h-screen flex flex-col bg-gradient-to-t from-primary-700 to-primary-800">
      <div className="h-screen flex flex-col items-center justify-center bg-dotted-effect bg-login relative">
        <div className="flex justify-center mb-6 h-40 relative">
          <SolidLogo className="h-40" />
          <p className="absolute bottom-9 ml-20 text-xs text-white whitespace-nowrap">
            BILLER PORTAL
          </p>
        </div>
        <main className="mx-2 flex flex-col items-center bg-white rounded-2xl p-4 w-full max-w-5xl">
          <div className="flex justify-between items-center w-full px-5 pt-3">
            <h1 className="text-xl font-semibold">Privacy Policy</h1>
            <button
              type="button"
              className=""
              onClick={() => history.push('/')}
            >
              <XIcon className="w-6 h-6" />
            </button>
          </div>
          <div className="flex flex-col space-y-4 p-5">
            <div className="flex flex-col space-y-6 h-96 overflow-y-auto bg-gray-100 py-6 px-3 rounded-lg">
              <ol className="list-decimal list-inside leading-relaxed space-y-6 pr-6">
                <li className="font-semibold text-lg">
                  Definition and Interpretation
                </li>
                <ol className="leading-relaxed space-y-4">
                  <li>
                    <span className="font-semibold">1.1.</span> This Privacy
                    Policy Specific Terms sets out to inform the Subscriber on
                    how the Service Provider collects, stores, uses, shares,
                    processes and protects Subscriber(s)’ personal information
                    set out in Clause 2.2 below.
                  </li>
                  <li>
                    <span className="font-semibold">1.2.</span> The General
                    Terms shall apply and govern each and/or all of the Services
                    in addition to any Specific Terms and Policies, and in the
                    event, there is a conflict or inconsistency between the
                    Terms, the documents shall be construed in the following
                    order of precedence:
                    <ul className="leading-relaxed py-4 space-y-2">
                      <li>
                        <span className="font-semibold">(i)</span> the
                        applicable Specific Terms; and
                      </li>
                      <li>
                        <span className="font-semibold">(ii)</span> the General
                        Terms.
                      </li>
                    </ul>
                    In the event such construction fails to resolve the conflict
                    or inconsistence, such conflict or inconsistency shall be
                    resolved in a manner most favourable to the Service
                    Provider, to the fullest extent permissible under the
                    applicable law.
                  </li>
                  <li>
                    <span className="font-semibold">1.3.</span> This Privacy
                    Policy Specific Terms shall apply and govern all products
                    and Services depicted on the Platform under the umbrella of
                    the General Terms.
                  </li>
                  <li>
                    <span className="font-semibold">1.4.</span> In this Privacy
                    Policy Specific Terms, words and expressions shall have the
                    same meaning as outlined in Clause 1.1 of the ‘General
                    Terms’ and Conditions of Services.
                  </li>
                  <li>
                    <span className="font-semibold">1.5.</span> Unless otherwise
                    stated with reference to any other Terms, any reference made
                    in this Privacy Policy Specific Terms to any Clauses shall
                    be interpreted as to Clauses within these terms.
                  </li>
                </ol>
                <li className="font-semibold text-lg">Personal Data</li>
                <ol className="leading-relaxed space-y-4">
                  <li>
                    <span className="font-semibold">2.1.</span> The Service
                    Provider ensures that only authorized staff will have access
                    to personal information shared by the Subscriber(s).
                  </li>
                  <li>
                    <span className="font-semibold">2.2.</span> The Service
                    Provider collects the following personal information which
                    is necessary for business function and activities:
                    <ol className="leading-relaxed pt-4 space-y-2">
                      <li>
                        <span className="font-semibold">2.2.1.</span> Name
                      </li>
                      <li>
                        <span className="font-semibold">2.2.2.</span> Email
                        address
                      </li>
                      <li>
                        <span className="font-semibold">2.2.3.</span> Billing
                        address
                      </li>
                      <li>
                        <span className="font-semibold">2.2.4.</span> Date of
                        Birth
                      </li>
                      <li>
                        <span className="font-semibold">2.2.5.</span> Gender
                      </li>
                      <li>
                        <span className="font-semibold">2.2.6.</span> Phone
                        number(s)
                      </li>
                      <li>
                        <span className="font-semibold">2.2.7.</span> Account
                        password and login details
                      </li>
                      <li>
                        <span className="font-semibold">2.2.8.</span> IP Address
                      </li>
                      <li>
                        <span className="font-semibold">2.2.9.</span>{' '}
                        Website/browsing history including geographical
                        location, length of visit and number of viewed pages
                      </li>
                      <li>
                        <span className="font-semibold">2.2.10.</span> Cookie
                        information
                      </li>
                    </ol>
                  </li>
                  <li>
                    <span className="font-semibold">2.3.</span> The Service
                    Provider will collect, store, use, share, process and
                    protect personal information from the Subscriber for the
                    following purposes, including but is not limited to:
                    <ol className="leading-relaxed pt-4 space-y-2">
                      <li>
                        <span className="font-semibold">2.3.1.</span> Verifying
                        the Subscriber’s identity upon login
                      </li>
                      <li>
                        <span className="font-semibold">2.3.2.</span> Making
                        Service(s) available to the Subscriber on the Platform
                      </li>
                      <li>
                        <span className="font-semibold">2.3.3.</span> Enhancing
                        the content on the Platform
                      </li>
                      <li>
                        <span className="font-semibold">2.3.4.</span> Improving
                        the Services to tailor your shopping experience
                      </li>
                      <li>
                        <span className="font-semibold">2.3.5.</span> Ensuring
                        the Platforms are presented in the most effective manner
                        for the Subscriber and their devices
                      </li>
                      <li>
                        <span className="font-semibold">2.3.6.</span> Showing
                        the Subscriber advertisements on social media platforms
                        and across websites
                      </li>
                      <li>
                        <span className="font-semibold">2.3.7.</span> Protecting
                        the rights of the Service Provider
                      </li>
                      <li>
                        <span className="font-semibold">2.3.8.</span> Enabling
                        the Service Provider to comply with any legal or
                        regulatory requirements and in the detection and
                        prevention of theft, fraud or other crimes
                      </li>
                    </ol>
                  </li>
                  <li>
                    <span className="font-semibold">2.4.</span> The Service
                    Provider may collect or share the Subscriber’s information
                    with trusted and authorised third-party service providers to
                    give the Subscriber a better customer experience, by
                    displaying relevant content and advertisements across
                    websites.
                  </li>
                  <li>
                    <span className="font-semibold">2.5.</span> The Service
                    Provider will not share, sell, rent, swap or authorise any
                    third party to use your personal information for commercial
                    purposes without your consent.
                  </li>
                  <li>
                    <span className="font-semibold">2.6.</span> The Service
                    Provider uses cookies to collect the Subscriber’s browsing
                    information for record-keeping, analysis and evaluation. A
                    Subscriber may refuse to accept the cookies on the browser
                    if the Subscriber is not acceptable to the collection of
                    data, which may affect the user experience and areas of
                    certain sites will not function properly.
                  </li>
                  <li>
                    <span className="font-semibold">2.7.</span> The Service
                    Provider has engaged in a variety of industry-standard
                    security technologies, procedures and processes and is
                    committed to protecting the security of the Subscriber’s
                    personal data.
                  </li>
                  <li>
                    <span className="font-semibold">2.8.</span> When sensitive
                    information (login data, credit card number, expiration
                    date) is provided, encryption is performed using secure
                    socket layer (SSL) technology.
                  </li>
                  <li>
                    <span className="font-semibold">2.9.</span> If you have any
                    questions on use of your data, you can contact us on the
                    information available on our Platform.
                  </li>
                </ol>
              </ol>
            </div>
            <div className="flex justify-center">
              <Button
                type="button"
                transparent
                onClick={() => history.push('/')}
              >
                Close
              </Button>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
